var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconQrCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 9.22222H4.55556V10.7778H3V9.22222ZM9.22222 4.55556H10.7778V7.66667H9.22222V4.55556ZM7.66667 9.22222H10.7778V12.3333H9.22222V10.7778H7.66667V9.22222ZM12.3333 9.22222H13.8889V10.7778H15.4444V9.22222H17V10.7778H15.4444V12.3333H17V15.4444H15.4444V17H13.8889V15.4444H10.7778V17H9.22222V13.8889H12.3333V12.3333H13.8889V10.7778H12.3333V9.22222ZM15.4444 15.4444V12.3333H13.8889V15.4444H15.4444ZM12.3333 3H16C16.5523 3 17 3.44772 17 4V7.66667H12.3333V3ZM13.8889 4.55556V6.11111H15.4444V4.55556H13.8889ZM3 4C3 3.44771 3.44772 3 4 3H7.66667V7.66667H3V4ZM4.55556 4.55556V6.11111H6.11111V4.55556H4.55556ZM3 12.3333H7.66667V17H4C3.44771 17 3 16.5523 3 16V12.3333ZM4.55556 13.8889V15.4444H6.11111V13.8889H4.55556Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQrCode);
export default __webpack_public_path__ + "static/media/IconQRCode.09be6a4c.svg";
export { ForwardRef as ReactComponent };